import { render, staticRenderFns } from "./SelectGestor.vue?vue&type=template&id=5f1b78b3&"
import script from "./SelectGestor.vue?vue&type=script&lang=js&"
export * from "./SelectGestor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports